import {useExtractPolicyDataMutation} from "../../redux/api/coverageConfirmationApiSlice";
import React, {useState} from "react";
import {Button, message, Modal} from "antd";
import {RedoOutlined} from "@ant-design/icons";

export const ImportPolicyData = ({cUuid, isSurveyDisabled} : {cUuid: string, isSurveyDisabled: boolean}) => {

    const [extractData, {isLoading}] = useExtractPolicyDataMutation()

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

    return <>
        <Modal
            open={isModalOpen}
            destroyOnClose
            onCancel={() => setIsModalOpen(false)}
            title={"Importa dati"}
            okText={"Importa"}
            okButtonProps={{loading: isLoading}}
            onOk={() => {
                extractData({cUuid}).unwrap()
                    .catch((res) => {
                        message.error(res.data.error)
                    })
                    .finally(()=> setIsModalOpen(false))
            }}
        >
            <div style={{marginBottom: 10}}>Sei sicuro di voler importare i dati da PASS? Alcuni dati presenti saranno sovrascritti.</div>
        </Modal>
        <Button
            type={"primary"}
            disabled={isSurveyDisabled}
            icon={<RedoOutlined/>}
            onClick={() => setIsModalOpen(true)}>
            Importa dati
        </Button>
    </>
}